<template lang="html">
  <div class="placed-backg contact-page-" id="page-info-t1">
    <!-- <div class="bg-image" v-bind:style="{ backgroundImage: 'url(public/images/pages/contact/bg.jpg)' }"></div> -->

    <section class="container content-section">
      <div class="row align-items-center justify-content-center">
        <div class="col-12 text-center col-info">
          <h5 class="text-center page-title txt-xl">Garantia</h5>
          <p></p>
        </div>

        <div class="col-lg-7 col-xl-6 col-info">
          <b-form class="mt-2" @submit="onSubmit">
            <b-form-group label="Fecha de garantia">
              <b-form-input
                v-model="form.date"
                type="date"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group label="No. de factura o ticket de compra:">
              <b-form-input
                v-model="form.number"
                type="number"
                required
                placeholder="00000000"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Codigo de producto:">
              <b-form-input
                v-model="form.code"
                type="text"
                required
                placeholder="Ingresa el código o número de parte de la refacción a garantía"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Descripción del problema o falla:">
              <b-form-textarea
                v-model="form.problem"
                placeholder="Describa la falla o problema que presenta su refacción"
                required
                rows="3"
                max-rows="3"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group label="Nombre del cliente, taller o empresa:">
              <b-form-textarea
                v-model="form.name"
                placeholder="Ingresa los datos de contacto. Nos comunicarnos lo antes posible"
                required
                rows="3"
                max-rows="3"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group label="Comentarios u observaciones del cliente:">
              <b-form-textarea
                v-model="form.comments"
                placeholder="Favor de agregar alguna observación o duda que no se encuentre en los campos anteriores"
                required
                rows="3"
                max-rows="3"
              ></b-form-textarea>
            </b-form-group>

            <p class="text-center">
              <b-button type="submit" class="btn-send">Enviar formulario</b-button>
            </p>
          </b-form>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        name: null,
        email: null,
        phone: null,
        msg: null
      },
      info: {
        contact:null,
      },
    }
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        appendToast: true
      })
    },

    getInfo: function(){
      axios.get(tools.url('/api/info')).then((response)=>{
        this.info = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },

    onSubmit(evt) {
      evt.preventDefault();
      //var data=tools.params(form, this.form);
      axios.post(tools.url("/api/contact"), this.form).then((response)=>{
          this.makeToast('default', response.data.response, 'Mensaje enviado');
          this.form = {
            name: null,
            email: null,
            msg: null,
            check: null
          };
        }).catch( (error)=> {
        // console.log(error.response);
        let errors = error.response.data;
        // console.log(errors);
        this.makeToast('danger', error.response.data.name, 'Error');
        this.makeToast('danger', error.response.data.email, 'Error');
        this.makeToast('danger', error.response.data.phone, 'Error');
        this.makeToast('danger', error.response.data.msg, 'Error');
      });
    }
  },

  beforeMount(){
    // this.getInfo();

    if(this.$route.query.p){
      this.form.msg = 'Me intresa el producto '+ this.$route.query.p;
    }
  }
}
</script>
